<template>
	<div id="app">
		<headmain v-if="$route.meta.hidenav!='hidenav'"></headmain>
		<router-view/>
		<footmain v-if="$route.meta.hidenav!='hidenav'"></footmain>
		<totop v-if="$route.meta.hidenav!='hidenav'"></totop>
		<im></im>
	</div>
</template>

<script>
	import headmain from '@/components/headmain'
	import footmain from '@/components/footmain'
	import totop from '@/components/totop'
	import im from '@/components/im'
	export default {
		name: 'app',
		components: {
			headmain,
			footmain,
			totop,
			im
		},
		data() {
			return {}
		},
		created() {

		},
		mounted() {

		},
		methods: {

		}
	}
</script>